import { render, staticRenderFns } from "./ProvidersButton.vue?vue&type=template&id=616918dd&scoped=true"
import script from "./ProvidersButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProvidersButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProvidersButton.vue?vue&type=style&index=0&id=616918dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616918dd",
  null
  
)

export default component.exports